import { DateTime } from 'luxon';

// required noise data for the Continuous Noise Graph and playback
// continuousNoiseData = <- 60 sec [noise - data]
export const getProcessedNoiseData = (
  noiseData,
  continuousNoiseData,
  continuousNoiseLength = 60
) => {
  const data: any = [];
  noiseData.forEach(dataSet => {
    const {
      locationId: selectedLocationId,
      startTime: eventStart,
      endTime: eventEnd,
      maxLevel,
      samples: { samples: noiseEvent },
    } = dataSet;
    let index = null;
    continuousNoiseData.forEach((element, i) => {
      const { locationId } = element;
      if (selectedLocationId === locationId) {
        index = i;
      }
    });
    const xPlotLineEnd = continuousNoiseLength - 0.5 + noiseEvent.length;

    if (index !== null) {
      const {
        samples: continuous,
        startTime: continuousStart,
        endTime: continuousEnd,
      } = continuousNoiseData[index];

      const firstMinute = continuous.slice(0, continuousNoiseLength);
      const lastMinute = continuous.slice(continuousNoiseLength + noiseEvent.length);

      const eventStr = noiseEvent.join();
      const continuousStr = continuous.join();

      data.push({
        valid: continuousStr.search(eventStr) !== -1,
        locationId: selectedLocationId,
        maxLevel,
        event: noiseEvent,
        eventStart,
        eventEnd,
        continuous,
        continuousStart,
        continuousEnd,
        stitched: [...firstMinute, ...noiseEvent, ...lastMinute],
        plotLines: [continuousNoiseLength - 0.5, xPlotLineEnd],
      });
    } else {
      const nullArray = new Array(continuousNoiseLength).fill(null);
      const start = DateTime.fromISO(eventStart)
        .minus({ minutes: 1 })
        .toISO();
      const end = DateTime.fromISO(eventEnd)
        .plus({ minutes: 1 })
        .toISO();

      data.push({
        valid: true,
        locationId: selectedLocationId,
        maxLevel,
        event: noiseEvent,
        eventStart,
        eventEnd,
        continuous: noiseEvent,
        continuousStart: start,
        continuousEnd: end,
        stitched: [...nullArray, ...noiseEvent, ...nullArray],
        plotLines: [continuousNoiseLength - 0.5, xPlotLineEnd],
      });
    }
  });
  return data;
};
